import { TYPE_DATE_COMPARISON } from './input-types';

export const id = 'shipByDate';
export const apiKey = 'ShipByDateTime';
export const type = TYPE_DATE_COMPARISON;

export const shipByDate = {
  id,
  apiKey,
  type,
};
